module.exports = "https://www.gc-qa.gnp.com.mx/37e49b40022a0c52a6f2b3258b6e3419.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/circle-poliza.svg
// module id = 214
// module chunks = 0